import type { SVGProps } from 'react';
const DawnFlagDO = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-DO_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-DO_svg__a)">
      <path
        fill="#083D7A"
        fillRule="evenodd"
        d="M0 6.4h9.429V0H0zM12.571 16H22V9.6H12.57z"
        clipRule="evenodd"
      />
      <path
        fill="#DF1E35"
        fillRule="evenodd"
        d="M0 16h9.429V9.6H0zM12.571 6.4H22V0H12.57z"
        clipRule="evenodd"
      />
      <mask id="dawn-flag-DO_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          d="M9.889 6.869a1.62 1.62 0 0 0 0 2.262 1.55 1.55 0 0 0 2.222 0 1.62 1.62 0 0 0 0-2.262"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#0F6D1A"
        d="M9.421 6.393a2.3 2.3 0 0 0 0 3.214l.935-.951a.94.94 0 0 1 0-1.312zm0 3.214a2.204 2.204 0 0 0 3.157 0l-.934-.951a.9.9 0 0 1-1.288 0zm3.157 0a2.3 2.3 0 0 0 0-3.214l-.934.951a.94.94 0 0 1 0 1.312z"
        mask="url(#dawn-flag-DO_svg__b)"
      />
      <path
        fill="#042F60"
        fillRule="evenodd"
        d="M11 8.533c.29 0 .524-.239.524-.533A.53.53 0 0 0 11 7.467a.53.53 0 0 0-.523.533c0 .294.234.533.523.533"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagDO;
